<template>
  <section v-on:click="sectionClicked" class="textBlock features" :class="section.id">
    <div class="sectionHeader" v-if="section.title || section.descriptions">
      <div class="cnt">
        <h4 class="sectionTitle" v-if="section.title[lang]">{{section.title[lang]}}</h4>
        <p class="sectionDesc" v-if="section.descriptions[lang]">{{section.descriptions[lang]}}</p>
        <a href="#" class="btn outline" v-if="section.url">Learn More</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'home',
  props: ['section'],
  components: {},
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.textBlock{
  .sectionHeader{
    text-align: center;
    z-index: 7;
    padding: 0 20px;
    @media (max-width: 680px) {
      padding: 0;
    }
    .sectionTitle{
      font-size: 46px;
      font-weight: 600;
      margin: 0 auto 16px;
      max-width: 700px;
      line-height: 1.2;
      font-family: 'Bebas Neue', sans-serif;
      letter-spacing: 1.2px;
      @media (max-width: 1480px) {
        font-size: 42px;
      }
      @media (max-width: 960px) {
        font-size: 36px;
      }
      @media (max-width: 680px) {
        font-size: 30px;
        // margin-bottom: 10px;
      }
    }
    .sectionDesc{
      color: inherit;
      margin: 0 auto;
      font-size: 20px;
      max-width: 860px;
      line-height: 1.5;
      padding: 0;
      white-space: pre-line;
      font-weight: 400;
      @media (max-width: 1480px) {
        font-size: 18px;
      }
      @media (max-width: 680px) {
        font-size: 16px;
        line-height: 1.3;
      }
    }
    .btn{
      font-size: 20px;
      font-weight: 400;
      margin: 30px 0 0;
      display: inline-block;
    }
  }
}

.textBlock.features.bye-text-orange{
  background-color: #FFCC00;
  position: relative;
  z-index: 3;
  margin: 50px 0 -200px;
  padding: 60px 0 180px;
  @media (max-width: 1560px) {
    margin-top: 30px;
  }
  @media (max-width: 840px) {
    margin-top: 0;
  }
  .cnt{
    position: relative;
    z-index: 3;
  }
  &:before{
    content: "";
    position: absolute;
    top: -150px; height: 300px;
    left: 0; right: 0;
    background-image: url(../../assets/divider-orange.png);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.textBlock.features.kampanye-bergerak-text-mural{
  background-color: #486CB1;
  position: relative;
  color: #fff;
  margin: 0;
  padding: 250px 0 80px;
  @media (max-width: 640px) {
    padding-top: 200px;
  }
  .sectionHeader{
    .sectionTitle{
      color: #FF9100;
      // font-size: 52px;
      line-height: 1.2;
    }
  }
  &:after{
    content: "";
    position: absolute;
    height: 200px; bottom: -200px;
    left: 0; right: 0;
    background-image: url(../../assets/blue-divider-bottom.png);
    background-size: 100% auto;
    background-position: top center;
    background-repeat: no-repeat;
  }
}

.textBlock.features.text-jika-seorang-migran{
  .sectionHeader .sectionDesc{
    max-width: 980px;
    font-size: 36px;
    font-family: Bebas Neue;
    color: #E9134F;
    padding-top: 60px;
    @media (max-width: 1024px) {
      font-size: 26px;
    }
    @media (max-width: 640px) {
      font-size: 20px;
    }
  }
}
</style>
